/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState, useMemo } from 'react'
// utils
import { isHexColorMuted, isLight } from 'utils/theme'
// material
import { ColorPicker, Switch, Tip } from '@insticator/insticator-ui/dist/material'
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './colors_styles'

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : COLORS ~~~~~~~~~~ ========== */
const Colors = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig, setSiteThemeConfigs, isConfigOpen } = props

  const [colorSchema, ] = useState({
    backgroundColor: siteTheme.backgroundColor,
    primaryColor: siteTheme.primaryColor
  })

  const [tempColors, setTempColors] = useState({
    primaryColor: siteTheme.primaryColor
  })

  const [colorSchemaValid, setColorSchemaValid] = useState({
      backgroundColor: true, primaryColor: true
  })


  useEffect(() => {
    if(!isConfigOpen) {
      setColorSchemaValid({backgroundColor: true, primaryColor: true})
      setTempColors({ primaryColor: siteTheme.primaryColor})
    } 
  },[isConfigOpen, siteTheme.primaryColor])


  const handlePrimaryColorChange = color => {
    setTempColors({ primaryColor: color })
    setSiteThemeConfig('primaryColor', color)
  }

  const handleBackgroundChange = (color) => {
    const modeStyle = isLight(color) ? 'LIGHT' : 'DARK'
    setSiteThemeConfigs({
      backgroundColor: color
    })
  }

  const validateColor = (isValid, name) => {
    setColorSchemaValid({
      ...colorSchemaValid,
      [name]: isValid
    })
  }

  const handleReset = (color) => setSiteThemeConfig(color, colorSchema[color])

  const handleMonochromeChange = () => {
    setSiteThemeConfigs({
      enableMonochrome: !siteTheme.enableMonochrome,
      primaryColor: 
        siteTheme.enableMonochrome ? (tempColors.primaryColor === '#000000' ? '#061240' : tempColors.primaryColor) 
        : tempColors.primaryColor
    })
  }

  const hasLowSaturation = useMemo(() => {
    if(siteTheme.enableMonochrome) return false
    return isHexColorMuted(siteTheme.primaryColor)
  }, [siteTheme.primaryColor, siteTheme.enableMonochrome])
      

  return (
    <SectionGroupV2 
      klass={`colors ${props.classes.colors}`}
      title={'Colors'} 
      description={'Match your sites color scheme by selecting some basic hues.'}
      direction={'column'}
    >
      <Space klass={'backgroundcolor'} alignItems={'center'}>
        <ColorPicker 
          valid={colorSchemaValid.backgroundColor}
          color={siteTheme.backgroundColor || '#FFFFFF'}
          savedColor={siteTheme.backgroundColor || '#FFFFFF'}
          label={<span>Background <Tip space={'none'} icon={'question-circle'} content={'This color should match the background color where your trending now unit will display.'} label={''} /></span>}
          handleColorChange={(color, e) => handleBackgroundChange(color)}
          processColorUpdate={(color, e) => handleBackgroundChange(color)}
          validateColor={(isValid, e) => validateColor(isValid, 'backgroundColor')}
          handleReset={() => handleReset('backgroundColor')} 
        />
      </Space>

    <Space klass={`primarycolor disabled-${!!siteTheme.enableMonochrome}`} alignItems={'center'}>
      <ColorPicker 
        valid={colorSchemaValid.primaryColor} 
        label={'Primary'} 
        color={siteTheme.primaryColor || '#061240'} 
        savedColor={siteTheme.primaryColor || '061240'} 
        processColorUpdate={(color, e) => {
          handlePrimaryColorChange(color)
        }}
        handleColorChange={(color, e) => handlePrimaryColorChange(color)}
        validateColor={(isValid, e) => validateColor(isValid, 'primaryColor')} 
        handleReset={() => handleReset('primaryColor')} 
      />
        <Space klass={'usemonochrome'} gap={8} alignItems={'center'}>
          <Switch 
            on={!!siteTheme.enableMonochrome} 
            handleClick={() => handleMonochromeChange(!siteTheme.enableMonochrome)} 
          />
          <span>Monochrome</span>
          <Tip 
            content={`When enabled, the trending now unit will display in grayscale.`}
            label={''}
          />
        </Space>
    </Space>
    <div className='errormessage'>{hasLowSaturation && `Color has low saturation. Please select another primary color.`}</div>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Colors